﻿import {
	Log,
} from '../shared/tsjs/shared-modules.bundle.js';

document.addEventListener('DOMContentLoaded', () => {
	Log.showDebugLog(true);
	Log.info('Main sites script loaded');
	initializeCartDelete();
	initializeEmailFriendForm();
	initializeCartDetails();
	initializeSearch();
	
});

function initializeCartDelete() {

	document.addEventListener('click', function (e) {
		const target = e.target as HTMLElement;
		const deleteLink = target.closest('.cart-item-delete') as HTMLElement;

		if (!deleteLink) {
			return;
		}

		e.preventDefault();
		(window as any).openModalDeleteProductModal(deleteLink.id);
	});
}

function confirmDeleteProduct(event) {
	event.preventDefault();

	const target = event.target as HTMLElement;
	if (!target) {
		return;
	}

	const modal = target.closest('.modal-container') as HTMLElement;
	if (!modal) {
		return;
	}
	
	const sourceId = modal.dataset.sourceId;
	if (!sourceId) {
		return;
	}

	const deleteLink = document.getElementById(sourceId) as HTMLElement;
	if (!deleteLink) {
		return;
	}

	const cartGroupId = deleteLink.dataset.cartgroupid;
	if (!cartGroupId) {
		return;
	}

	const tokenElement = document.querySelector(
		'input[name="__RequestVerificationToken"]'
	) as HTMLInputElement;

	const apiUrl = deleteLink.dataset.deleteUrl;
	if (!apiUrl) {
		return;
	}

	fetch(apiUrl, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'RequestVerificationToken': tokenElement?.value || ''
		},
		body: JSON.stringify({
			cartGroupId: cartGroupId
		})
	})
		.then(function (response) {

			if (!response.ok) {
				throw new Error('Delete failed');
			}

			return response.json();
		})
		.then(function (result) {

			if (result.success) {
				const isCheckoutPage = window.location.pathname.toLowerCase().indexOf("/checkout") !== -1

				if (isCheckoutPage) {
					window.location.reload();
					return;
				}

				const cartItemGroup =
					deleteLink.closest('.cart-item-group');

				if (cartItemGroup) {
					cartItemGroup.remove();
				}
				window.location.reload();
			} else {

				alert(result.message || 'Delete failed');
			}
		})
		.catch(function (error) {

			console.error(error);

			alert('Delete failed');
		});
}
function initializeEmailFriendForm() {

	document.addEventListener("submit", function (e) {

		const form = e.target as HTMLFormElement;

		if (!form || form.id !== "emailFriendForm") {
			return;
		}

		e.preventDefault();

		const request = {
			recipientEmail: (document.getElementById("RecipientEmail") as HTMLInputElement).value,
			senderName: (document.getElementById("SenderName") as HTMLInputElement).value,
			senderEmail: (document.getElementById("SenderEmail") as HTMLInputElement).value,
			message: (document.getElementById("Message") as HTMLTextAreaElement).value,
			productId: parseInt((document.getElementById("ProductId") as HTMLInputElement).value),
			itemId: parseInt((document.getElementById("ItemId") as HTMLInputElement).value)
		};
		const token = (
			document.querySelector(
				'input[name="__RequestVerificationToken"]'
			) as HTMLInputElement
		)?.value;
		var apiUrl = form.dataset.apiUrl || "/api/email/friend";
		fetch(apiUrl, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"RequestVerificationToken": token || ""
			},
			body: JSON.stringify(request)
		})
			.then(function (response) {

				if (!response.ok) {
					throw new Error("Email send failed");
				}

				return response.json();
			})
			.then(function (result) {
				if (result.success) {
					(window as any).closeModalEmailFormModal();

					alert("Email sent successfully");
				}
				else {
					alert(result.message || "Email send failed");
				}
				form.reset();
			})
			.catch(function (error) {

				console.error(error);

				alert("Email send failed");
				form.reset();
			});
	});
}

function initializeCartDetails() {
	
	document.addEventListener("click", function (e) {

		const target = e.target as HTMLElement;

		const detailsLink = target.closest(".cart-item-details") as HTMLElement;
		
		if (!detailsLink) {
			return;
		}

		e.preventDefault();

		const cartGroupId = detailsLink.dataset.cartgroupid;
		
		if (!cartGroupId) {
			return;
		}

		const container = document.getElementById("cartGroupDetailsContent");

		if (!container) {
			return;
		}

		const detailsUrl = container.getAttribute("data-details-url");

		if (!detailsUrl) {
			return;
		}

		fetch(detailsUrl + "?cartGroupId=" + cartGroupId)
			.then(function (response) {

				if (!response.ok) {
					throw new Error("Unable to load details.");
				}

				return response.text();
			})
			.then(function (html) {
				container.innerHTML = html;
				(window as any).openModalCartGroupDetailsModal();
			})
			.catch(function (error) {

				console.error(error);

				alert("Unable to load details.");
			});
	});
}

function initializeSearch() {
	const searchInput = document.getElementById('searchString') as HTMLInputElement | null;
	const searchSubmit = document.getElementById('search-submit');

	if (!searchInput) {
		return;
	}
	const searchUrl = searchSubmit.getAttribute('data-search-url');
	if (!searchUrl) {
		return;
	}
	searchInput.addEventListener('keydown', (e: KeyboardEvent) => {
		if (e.key === 'Enter') {
			e.preventDefault();
			startSearch(searchInput.value, searchUrl);
		}
	});

	searchSubmit?.addEventListener('click', () => {
		startSearch(searchInput.value, searchUrl);
	});
}

function startSearch(searchTerm: string, searchUrl: string) {
	const term = searchTerm.trim();

	if (!term) {
		return;
	}

	const url = new URL(searchUrl, window.location.origin);
	url.searchParams.set('sf', '1');
	url.searchParams.set('searchString', term);

	window.location.href = url.toString();
}

/**
 * TypeScript replacement for the jQuery PmallRecentView object
 */
const PmallRecentView = {
	storageName: 'ProductVisitedStorage',
	storage: window.localStorage,
	fetchUrl: '',
	divId: '',
	maxListCount: 25,
	/**
	 * Initialize the recently viewed manager
	 */
	init(options: { id: string; url: string; maxListCount: number }): void {
		if (typeof this.storage !== 'undefined') {
			this.divId = options.id;
			this.fetchUrl = options.url;
			this.maxListCount = options.maxListCount;
		}
	},

	/**
	 * Add a visited product to the list
	 */
	addVisitedProduct(productId: number): void {
		if (!productId) return;

		let savedList: number[] = [];

		if (!this.storage.getItem(this.storageName)) {
			savedList = [productId];
		} else {
			try {
				const parsed = JSON.parse(this.storage.getItem(this.storageName) || '[]');
				savedList = Array.isArray(parsed) ? parsed : [];
			} catch (err) {
				Log.warn('Failed to parse recently viewed storage, clearing it');
				this.storage.removeItem(this.storageName);
				savedList = [productId];
			}

			// Check if product already exists
			const found = savedList.includes(productId);
			if (!found) {
				// Remove oldest if at max capacity
				if (savedList.length >= this.maxListCount) {
					savedList.shift();
				}
				// Add new product
				savedList.push(productId);
			} else {
				// Move existing product to end (most recent)
				savedList = savedList.filter(id => id !== productId);
				savedList.push(productId);
			}
		}

		this.storage.setItem(this.storageName, JSON.stringify(savedList));
	},

	/**
	 * Show recently viewed products
	 */
	showVisitedProduct(hideFirstProduct: boolean = false): void {
		const storedData = this.storage.getItem(this.storageName);

		if (!storedData) {
			this.hideSection();
			return;
		}

		let savedListContent: number[];
		try {
			savedListContent = JSON.parse(storedData);
		} catch (err) {
			Log.warn('Failed to parse recently viewed storage');
			this._hideSection();
			return;
		}

		// Remove current product if specified
		if (hideFirstProduct && savedListContent.length > 0) {
			savedListContent.pop();
		}

		// Hide section if no products
		if (savedListContent.length === 0) {
			this._hideSection();
			return;
		}

		// Reverse to show most recent first
		const reversedIds = savedListContent.reverse();
		const url = this.fetchUrl + reversedIds.join(',');
		fetch(url, { cache: 'no-store' })
			.then(response => {
				if (!response.ok) {
					throw new Error('Failed to load recently viewed');
				}
				return response.text();
			})
			.then(html => {
				const container = document.getElementById(this.divId);
				if (container) {
					container.innerHTML = html;
				}
			})
			.catch(error => {
				Log.error('Error loading recently viewed products:', error);
				this.hideSection();
			});
	},

	/**
	 * Hide the recently viewed section
	 */
	_hideSection(): void {
		const container = document.getElementById(this.divId);
		if (container) {
			container.classList.add('hid');
		}
	}
};



(window as any).confirmDeleteProduct = confirmDeleteProduct;
(window as any).PmallRecentView = PmallRecentView;
